import { classNames } from "common";
import { Link } from "react-router-dom";
import tw from "tailwind-styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ViewAllLink = tw(Link)`
font-mono
text-sm
`;
export function LandingSection(_ref) {
  let {
    action,
    left,
    title,
    children,
    className
  } = _ref;
  return /*#__PURE__*/_jsxs("section", {
    className: "pt-12 pb-16",
    children: [/*#__PURE__*/_jsxs("div", {
      className: classNames("flex justify-between items-center  mb-8", className),
      children: [left, title && /*#__PURE__*/_jsx("h3", {
        className: "text-xl md:text-3xl font-medium tracking-tight",
        children: title
      }), /*#__PURE__*/_jsx("div", {
        children: action
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: children
    })]
  });
}